import { Injectable, Signal, signal } from '@angular/core';

/**
 * Reactive viewport-size flags mirroring the app's two responsive tiers.
 * The queries use the exact rem values Tailwind v4 emits for its `max-md` /
 * `max-lg` variants (48rem/64rem with the .9975 epsilon) so templates using
 * breakpoint utilities and TS logic reading these signals flip at the same
 * width, even when the root font-size is not 16px.
 */
@Injectable({ providedIn: 'root' })
export class ViewportService {
  /** < 48rem (Tailwind md) — phone shell: drawer nav, compact topbar. */
  readonly isMobile: Signal<boolean> = fromQuery('(max-width: 47.9975rem)');

  /** < 64rem (Tailwind lg) — compact detail: side panels become sheets. */
  readonly isCompactDetail: Signal<boolean> = fromQuery('(max-width: 63.9975rem)');
}

/** Signal over a media query; lives for the app's lifetime (root singleton). */
function fromQuery(query: string): Signal<boolean> {
  const mql = window.matchMedia(query);
  const matches = signal(mql.matches);
  mql.addEventListener('change', (e) => matches.set(e.matches));
  return matches.asReadonly();
}
